import {commonService} from '../services/common';
import {cr} from 'fire-wind-water';

export class Thirdanalytics {
  constructor(private tenantId: string | number) {
    this.init();
  }

  getThirdanaly() {
    commonService.getThirdanaly({tenantId: this.tenantId}).subscribe((res: any) => {
      if (parseInt(res.result, 10) === 0) {
        if (res.content?.items) {
          cr.each(res.content.items, d => {
            if (d.thirdConfigValue) {
              this.create(d.thirdName, d.thirdConfigValue);
            }
          });
        }
      }
    });
  }

  init() {
    this.getThirdanaly();
  }

  create(type, id) {
    switch (type) {
      case 'ga':
        const ga = document.getElementById('ga');
        if (!ga) {
          const gaNode = document.createDocumentFragment();
          const gaUrl = document.createElement('script');
          gaUrl.type = 'text/javascript';
          gaUrl.async = true;
          gaUrl.id = 'ga';
          gaUrl.src = 'https://www.googletagmanager.com/gtag/js?id=' + id;
          gaNode.appendChild(gaUrl);
          const gaScript = document.createElement('script');
          gaScript.type = 'text/javascript';
          gaScript.appendChild(document.createTextNode(
            `window.dataLayer = window.dataLayer || []; function gtag(){window.dataLayer.push(arguments);} gtag("js",new Date()); gtag("config","${id}");`));
          gaNode.appendChild(gaScript);
          document.head.appendChild(gaNode);
        }
        break;
      case 'baidu':
        const baidu = document.getElementById('baidu');
        if (!baidu) {
          var baiduScript = document.createElement('script');
          baiduScript.id = 'baidu';
          baiduScript.appendChild(document.createTextNode(
            `var _hmt = _hmt || []; (function(){var hm = document.createElement('script');hm.src = "https://hm.baidu.com/hm.js?${id}";var s = document.getElementsByTagName("script")[0];s.parentNode.insertBefore(hm,s);})();`));
          document.head.appendChild(baiduScript);
        }
        break;
      case 'cnzz':
        const cnzz = document.getElementById('cnzz');
        if (!cnzz) {
          const cnzzScript = document.createElement('script');
          cnzzScript.id = 'cnzz';
          cnzzScript.type = 'text/javascript';
          cnzzScript.src = `https://v1.cnzz.com/z_stat.php?id=${id}&web_id=${id}`;
          document.head.appendChild(cnzzScript);
        }
        break;
    }
  }
}